import { DecimalPipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { HeroBinder } from '@components/partials/hero-binder/hero-binder';
import { UiModule } from '@components/ui/ui-module';
import { Binder, CardBinder, UserBinder } from '@models/binder.model';
import { Card } from '@models/card.model';
import { Card as CardService } from '@services/card.service';

@Component({
  selector: 'lgb-binder-overview',
  imports: [
    HeroBinder,
    DecimalPipe,
    UiModule
  ],
  templateUrl: './binder-overview.html',
  styleUrl: './binder-overview.css',
})
export class BinderOverview {
  readonly uBinder=input.required<UserBinder>();
  readonly binder=input.required<Binder>();
  readonly cards=input.required<CardBinder[]>();
  readonly references=input.required<Card[]>();
  readonly admin=input(true);

  //services
  readonly CardS=inject(CardService);

  //data
  readonly capacity=computed(() => ((this.binder())? this.binder().width*this.binder().height*this.binder().nbPage : 0));
  readonly condAvg=computed(() => this.getConditionAvg());
  readonly rarityAvg=computed(() => this.getRarityAvg());

  getNbDoubles(){
    let doubles=0;
    const cardMap=new Map<string, number>();
    this.cards().forEach(card => {
      let qte: number=1;
      if(cardMap.get(card.card))
        qte=cardMap.get(card.card)+1;
      cardMap.set(card.card, qte);
    });

    cardMap.forEach(v => {
      doubles+=v-1;
    });

    return doubles;
  }

  getConditionAvg(){
    return this.CardS.getConditionAvg(this.cards());
  }

  getRarityAvg(){
    return this.CardS.getRarityAvg(this.cards(), this.references());
  }

}
